import styled from 'styled-components';
import { Colors } from '~/config/Colors';
import Card from '~/pages/Sistema/componentes/Card';

export const Container = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;

  .sessao-quantidade {
    display: flex;
    flex-direction: row;
    
    .color1 {
      color: #9747FF;
    }
    
    .color2 {
      color: #4D78AD;
    }
    
    .color3 {
      color: #339C89;
    }
    
    .color4 {
      color: #99396D;
    }
    
    .color5 {
      color: #399948;
    }

    .item-quantidade {
      width: 11.15em;
      height: 7.6em;
      background: ${Colors.Color13};
      margin-right: 1em;
      border-radius: 0.9em;
      padding: 1.3em 1.5em;

      .item-header {
        display: flex;
        flex-direction: row;
        width: 100%;
        align-items: flex-start;
        justify-content: space-between;
        height: 3.2em;

        .item-numero {
          display: flex;
          height: 100%;
          align-items: flex-end;
          position: relative;
          margin-right: 3em;

          h5 {
            position: absolute;
            top: 30%;
            font-size: 1.2em;
          }
          
        }
      }
      
      .item-body {
        .pre-titulo-body {
          font-size: 0.7em;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
          width: 100%;
          font-weight: 600;
        }

        .titulo-body {
          font-size: 0.75em;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
          width: 100%;
          font-weight: 800;
          color: #8F9DAF;
        }
      }
    }
  }
`;

export const SectionPizza = styled.div`
  position: relative;
  width: 48%;
  min-height: 2em;
  margin-top: 2em;
  border-radius: 0.9375em;
  padding: 1.25em;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  background: ${Colors.Color13};

  .div-icone {
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;
    background: ${Colors.Color2};
    border-radius: 0.4em;
    padding: 0.15em 0.8em 0.15em 0.3em;
    width: fit-content;
    margin-bottom: 1.5em;

    img {
      width: 1.4em;
    }

    .title {
      font-size: 0.7125em;
      font-weight: 700;
      color: ${Colors?.Color7};
      margin-left: 0.5em;
    }
  }
  .chart-wrapper{
    height: 18em;
    width: 18em;
    margin-top: 2em;
    margin-left: 3em;
    margin-bottom: 2em;
    border-style: none;
  }

  .grafico-pizza{
    background: #6B39AC;
    height: 18em;
    width: 18em;
    border-radius: 10em;
    margin-top: 2em;
    margin-left: 3em;
    margin-bottom: 2em;
  }
`;

export const SectionBarra = styled.div`
  position: relative;
  width: 50%;
  min-height: 2em;
  margin-top: 2em;
  border-radius: 0.9375em;
  padding: 1.25em;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  background: ${Colors.Color13};

  .div-icone {
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;
    background: ${Colors.Color2};
    border-radius: 0.4em;
    padding: 0.15em 0.8em 0.15em 0.3em;
    width: fit-content;
    margin-bottom: 1.5em;

    img {
      width: 1.4em;
    }

    .title {
      font-size: 0.7125em;
      font-weight: 700;
      color: ${Colors?.Color7};
      margin-left: 0.5em;
    }
  }

  .grafico-pizza{
    background: #6B39AC;
    height: 18em;
    width: 18em;
    border-radius: 10em;
    margin-top: 2em;
    margin-left: 3em;
    margin-bottom: 2em;
  }

`;

export const SectionProjeto = styled.div`
  position: relative;
  width: 100%;
  min-height: 2em;
  margin-top: 2em;
  border-radius: 0.9375em;
  padding: 1.25em;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  background: ${Colors.Color13};

  .card{
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-bottom: 1.3em;
  }

  .item{
    background: #1D1D1D;
    height: fit-content;
    width: 97%;
    padding: 1.25em;
    border-bottom-right-radius: 0.7em;
    border-bottom-left-radius: 0.7em;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
  }

  .div-icone {
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;
    background: ${Colors.Color2};
    border-radius: 0.4em;
    padding: 0.15em 0.8em 0.15em 0.3em;
    width: fit-content;
    margin-bottom: 1.5em;

    img {
      width: 1.4em;
    }

    .title {
      font-size: 0.7125em;
      font-weight: 700;
      color: ${Colors?.Color7};
      margin-left: 0.5em;
    }
  }

  .grafico-pizza{
    background: #6B39AC;
    height: 18em;
    width: 18em;
    border-radius: 10em;
    margin-top: 2em;
    margin-left: 3em;
    margin-bottom: 2em;
  }
`;

export const ThisCard = styled.div`
  padding: 0.8em 0.8em 0.8em 1.5em;
  border-radius: 0.85em;
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: 100%;
  height: 5.2em;
  position: relative;
  overflow: hidden;
  background: ${localStorage.getItem("tema") == "E" ? Colors.Color26 : Colors.Color2};
  box-shadow: none !important;

  ${props => {
    if (props?.ativo) {
      return `border: 0.1em solid ${Colors.Color8};`;
    }
  }}

  .top {
    display: flex;
    flex-direction: row;
    justify-content: space-between;

    .content-top {
      display: flex;
      flex-direction: column;

      .card-cod {
        background: ${Colors.Color4};
        border-radius: 0.4em;
        padding: 0.2em 0.6em;
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: center;
        width: 3em;

        .cod {
          font-size: 0.7em;
          font-weight: bold;
          color: ${Colors.Color23};
        }
      }

      .card-top {
        line-height: 0.9em;

        .titulo {
          font-size: 0.8em;
          font-weight: bold;
          color: ${Colors.Color4};
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
          width: 20em;
        }

        .analista {
          font-size: 0.7em;
          font-weight: 600;
          color: ${Colors.Color14};
        }
      }
    }

    .content-progress{
      display: flex;

      .card-content {
        display: flex;
        flex-direction: row;
        align-items: center;

        .titulo {
          font-size: 0.7em;
          font-weight: bold;
          color: ${Colors.Color14};
          margin-left: 0.5em;
        }

        .progress {
          width: 15em;
          margin-left: 0.5em;
          margin-right: 1.5em;
          border-radius: 1em;
          background: ${localStorage.getItem("tema") == "E" ? "#1D1D1D" : "#FFFFFF"};
          height: 0.75em;
        }
      }
    }
  }

  .content-os {
    margin-top: 1em;
    display: flex;

    .info {
      display: flex;
      flex-direction: row;
      width: 80%;
      
      .item-info {
        display: flex;
        flex-direction: row;
        align-items: center;
        height: fit-content;
        margin-right: 1.5em;

        .data {
          font-size: 0.6em;
          font-weight: bold;
          color: ${Colors.Color14};
          margin-left: 0.5em;
        }
      }
    }
  }
`;

export const ThisCardItem = styled.div`
  padding: 0.8em;
  border-radius: 0.7em;
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: 97%;
  height: 3.2em;
  position: relative;
  overflow: hidden;
  background: ${localStorage.getItem("tema") == "E" ? Colors.Color26 : Colors.Color2};
  box-shadow: none !important;
  margin-bottom: 0.7em;

  .barra {
    background: ${Colors.Color4};
    height: 2em;
    width: 0.25em;
    left: 0;
    border-radius: 0.7em;
    position: absolute;
  }

  .top {
    display: flex;
    flex-direction: row;
    justify-content: space-between;

    .content-top {
      display: flex;
      flex-direction: column;

      .card-cod {
        background: ${Colors.Color4};
        border-radius: 0.4em;
        padding: 0.2em 0.6em;
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: center;
        width: 3em;

        .cod {
          font-size: 0.7em;
          font-weight: bold;
          color: ${Colors.Color23};
        }
      }

      .card-top {
        line-height: 0.9em;

        .titulo {
          font-size: 0.75em;
          font-weight: bold;
          color: ${Colors.Color4};
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
          width: 20em;
        }

        .analista {
          font-size: 0.65em;
          font-weight: 600;
          color: ${Colors.Color14};
        }
      }
    }

    .content-progress{
      display: flex;

      .card-content {
        display: flex;
        flex-direction: row;
        align-items: center;

        .titulo {
          font-size: 0.7em;
          font-weight: bold;
          color: ${Colors.Color14};
          margin-left: 0.5em;
        }

        .progress {
          width: 10em;
          margin-left: 0.5em;
          margin-right: 1.5em;
          border-radius: 1em;
          background: ${localStorage.getItem("tema") == "E" ? "#1D1D1D" : "#FFFFFF"};
          height: 0.75em;
        }
      }
    }
  }

`;

export const ThisProgress = styled.div`
  position: relative;
  display: flex;
  justify-content: flex-start;
  content: "";
  width: ${props => props?.width};
  height: 0.75em;
  border-radius: 1em;
  background: ${props => props?.backgound};
`;

export const ReactPizza = styled.div`
`;

export const ReactBarra = styled.div`
`;